import _ from "lodash";
export const generateTableData = (leadData) => {
    if (leadData && !_.isEmpty(leadData)) {
        let arrayOfObjects = [...leadData?.eligibleAssetData?.MUTUAL_FUND, ...leadData?.nonEligibleAssetData?.MUTUAL_FUND];
        return arrayOfObjects;
    }
    return [];
    // Creating a map based on fundType
    // Grouping the objects by fundType
    //     const groupedByFundType: { [key: string]: any[] } = arrayOfObjects.reduce((acc, obj) => {
    //         const { fundType } = obj;
    //         if (!acc[fundType]) {
    //             acc[fundType] = [];
    //         }
    //         acc[fundType].push(obj);
    //         return acc;
    //     }, {});
    //     return groupedByFundType;
};
